import { useState } from "react";
import { search_Resumes } from "../pages/library/helper"; // Make sure the path is correct

export const useResumeFetcher = () => {
  const [filters, setFilters] = useState({
    page: 1,
    page_size: 10,
    job_title: "",
    career_level: "",
    industry: "",
    region: "",
    job_family: "",
  });
  const [resumesData, setResumesData] = useState({
    resumes: [],
    job_families: [],
    total_count: 0,
    current_page: 1,
    total_pages: 1,
    has_next:false,
    has_prev:false,
  });
  const [isLoading, setIsLoading] = useState(true);

  const getResumes = async (updateFilters = {}) => {
    try {
      setIsLoading(true);

      const mergedFilters = { ...filters, ...updateFilters };
      setFilters(mergedFilters); // Save the latest filters

      const response = await search_Resumes(mergedFilters);
      console.log(response);

      // setResumes(response || []);
      setResumesData({
        resumes: response.resumes || [],
        job_families: response.job_families || [],
        total_count: response.total_count || 0,
        current_page: response.current_page || 1,
        total_pages: response.total_pages || 1,
        has_next: response.has_next || false,
        has_prev: response.has_prev || false,

      });

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching resumes:", error);
    }
  };

  return { resumesData, isLoading, getResumes, filters };
};
